module.exports = __webpack_public_path__ + "img/delivery_3.4c8dfaca.png";